import { Box, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { FC } from "react";
import { Control, FieldValues, UseFormWatch } from "react-hook-form";
import { borderRadius, borderStyle } from "../../../../utils/styles/styles";
import CheckboxComponent from "../../../../components/molecule/Checkbox/CheckboxComponent";
import NumberInputFieldComponent from "../../../../components/molecule/NumberInputField/NumberInputFieldComponent";

interface AlertStateFormProps {
  errors: any;
  control: Control<any>;
  isDisabled?: boolean;
  watch: UseFormWatch<FieldValues>;
  selectedIndicatorMetric: string;
}

const AlertStateForm: FC<AlertStateFormProps> = ({
  errors,
  control,
  isDisabled,
  watch,
  selectedIndicatorMetric,
}) => {
  const selectedBelowAbsoluteLevel = watch("belowAbsoluteLevel");
  const selectedAboveAbsoluteLevel = watch("aboveAbsoluteLevel");
  const selectedAlertVariationCheck = watch("alertVariationCheck");

  return (
    <Stack
      spacing={4}
      border={borderStyle}
      borderRadius={borderRadius}
      background="gray.50"
      p={6}
    >
      <Heading as="h3" fontSize="2xl">
        Estado de alerta
      </Heading>
      <Flex gap={4} direction="column">
        <Flex gap={2} direction="column">
          <Heading as="h4" fontSize="xl">
            Valor absoluto
          </Heading>
          <Text>
            O indicador deverá estar em alerta sempre que registar valores:
          </Text>
          <Flex gap="4" alignItems="flex-start">
            <Box>
              <NumberInputFieldComponent
                label="Abaixo de:"
                name="belowAbsoluteLevel"
                errors={errors}
                isDisabled={isDisabled}
                extraText={selectedIndicatorMetric}
                control={control}
              />
            </Box>
            <Box>
              <NumberInputFieldComponent
                label="Acima de:"
                name="aboveAbsoluteLevel"
                errors={errors}
                isDisabled={isDisabled}
                extraText={selectedIndicatorMetric}
                control={control}
              />
            </Box>
          </Flex>
        </Flex>

        <Flex gap={4} direction="column">
          <Heading as="h4" fontSize="xl">
            Variações
          </Heading>
          <CheckboxComponent
            name="alertVariationCheck"
            register={control.register}
            errors={errors}
            isDisabled={isDisabled}
            isRequired={
              selectedBelowAbsoluteLevel && selectedAboveAbsoluteLevel
            }
            description="Considerar alertas de acordo com as variações do indicador"
          ></CheckboxComponent>
          {selectedAlertVariationCheck && (
            <>
              <NumberInputFieldComponent
                label="Considerar variações apenas se o valor absoluto do indicador for superior a:"
                name="superiorAbsoluteValue"
                errors={errors}
                isDisabled={isDisabled}
                extraText={selectedIndicatorMetric}
                control={control}
                additionalStyle={{ maxWidth: "32" }}
                isRequired={selectedAlertVariationCheck}
              />
              <Flex gap={2} direction="column">
                <Text fontSize="md" fontWeight="500">
                  Considerar alerta se as variações para o período forem:
                </Text>
                <Flex gap="4" alignItems="flex-start">
                  <Box>
                    <NumberInputFieldComponent
                      label="Negativas em mais de:"
                      name="minPeriodVariation"
                      errors={errors}
                      isDisabled={isDisabled}
                      extraText="%"
                      control={control}
                    />
                  </Box>
                  <Box>
                    <NumberInputFieldComponent
                      label="Positivas em mais de:"
                      name="maxPeriodVariation"
                      errors={errors}
                      isDisabled={isDisabled}
                      extraText="%"
                      control={control}
                    />
                  </Box>
                </Flex>
              </Flex>
              <Flex gap={2} direction="column">
                <Text fontSize="md" fontWeight="500">
                  Considerar alerta se as variações anuais forem:
                </Text>
                <Flex gap="4" alignItems="flex-start">
                  <Box>
                    <NumberInputFieldComponent
                      label="Negativas em mais de:"
                      name="inferiorYearlyLevelVariations"
                      errors={errors}
                      isDisabled={isDisabled}
                      extraText="%"
                      control={control}
                    />
                  </Box>
                  <Box>
                    <NumberInputFieldComponent
                      label="Positivas em mais de:"
                      name="superiorYearlyLevelVariations"
                      errors={errors}
                      isDisabled={isDisabled}
                      extraText="%"
                      control={control}
                    />
                  </Box>
                </Flex>
              </Flex>
            </>
          )}
        </Flex>
      </Flex>
    </Stack>
  );
};

export default AlertStateForm;
